import { put, takeLatest, fork, call } from "redux-saga/effects";

import {
  ActionType,
  BodyTemperatureData,
  DataStatisticsResponse,
} from "models/bodyTemperature/statistics";
import { httpStatus } from "configs/httpStatus";
import { fetchStatisticsData } from "services/bodyTemperature";

import { handleSuccesAction, handleErrorAction } from "./statisticsActions";

function* getDataStatisticsSaga({ payload }: { payload: BodyTemperatureData }) {
  try {
    const response: DataStatisticsResponse = yield call(
      fetchStatisticsData,
      payload
    );
    if (response.status === httpStatus.StatusOK) {
      yield put(handleSuccesAction(response));
    } else {
      yield put(handleErrorAction(response.message || ""));
    }
  } catch (error) {
    yield put(handleErrorAction("error"));
  }
}
function* onGetDataStatisticsWatcher() {
  yield takeLatest(ActionType.DATA_STATISTICS as any, getDataStatisticsSaga);
}

export default [fork(onGetDataStatisticsWatcher)];
